// Centralized quality color logic for Cavern of Time / WoW items
// Index corresponds to item quality integer (0-7). Extend if needed.
export const QUALITY_BORDER_COLORS = [
  '#555',      // -1 / fallback (we won't actually index -1)
  '#9d9d9d',   // 0 Poor (using standard gray)
  '#ffffff',   // 1 Common
  '#1eff00',   // 2 Uncommon
  '#0070dd',   // 3 Rare
  '#a335ee',   // 4 Epic
  '#ff8000',   // 5 Legendary
  '#e6cc80'    // 6 Artifact (or heirloom styled)
];

export function getQualityBorderColor(quality){
  if(typeof quality !== 'number' || quality < 0) return '#FFD70044';
  return QUALITY_BORDER_COLORS[quality] || '#FFD700';
}
